import {
  AfterContentInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { StringVariable } from '../../../../../core/string-variable';

import { CountryService } from '../../../../../network/services/country.service';

import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-show-field-schema-value',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './show-field-schema-value.component.html',
  styleUrl: './show-field-schema-value.component.scss',
})
export class ShowFieldSchemaValueComponent
  implements OnInit, OnChanges, AfterContentInit, OnDestroy
{
  @Input() displayList: any = [];
  @Input() skipHeader: boolean = false;
  @Input() skipHeading: boolean = false;
  @ViewChild('rowContainer') rowContainer!: ElementRef;
  isWideScreen = true;
  clonedList: any[] = [];

  constructor(
    public variables: StringVariable,
    public _countryService: CountryService,
    private ref: ChangeDetectorRef,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.clonedList.forEach((obj: any) => {
      obj.fieldSchemaValues.forEach((val: any) => {
        // schema names
        if (obj.fieldSchema?.name) {
          if (/[a-z]/.test(obj.fieldSchema.name?.charAt(0))) {
            const result = obj.fieldSchema.name.replace(/([A-Z])/g, ' $1');
            let finalResult = result.charAt(0).toUpperCase() + result.slice(1);
            obj.fieldSchema.name = finalResult;
          }
        }
      });
    });
  }

  ngOnChanges(changes: any) {
    this.clonedList = JSON.parse(JSON.stringify(this.displayList));
    if (this.clonedList.length > 0) {
      this.clonedList.forEach((obj: any) => {
        if (obj.fieldSchema.fldSchmaSlctOptnFrmDb) {
          this.getFieldSchemaValueDetailsForSelectOption(obj.id, obj);
        }
        if (obj.fieldSchemaValues.length > 0) {
          obj.fieldSchemaValues.forEach((val: any) => {
            this.getSelectOptionForNested(val);
          });
        }
      });
    }
    this.ref.detectChanges();
  }

  ngAfterViewInit() {
    this.checkRowWidth();
    this.cdr.detectChanges();
  }

  @HostListener('window:resize', [])
  checkRowWidth() {
    if (this.rowContainer) {
      const rowWidth = this.rowContainer.nativeElement.offsetWidth;
      const newIsWideScreen = rowWidth > 700;
      if (this.isWideScreen !== newIsWideScreen) {
        this.isWideScreen = newIsWideScreen;
        this.cdr.detectChanges();
      }
    }
  }

  getSelectOptionForNested(obj: any) {
    if (obj.fieldSchema.fldSchmaSlctOptnFrmDb) {
      this.getFieldSchemaValueDetailsForSelectOption(obj.id, obj);
    }
    if (obj.fieldSchemaValues.length > 0) {
      obj.fieldSchemaValues.forEach((val: any) => {
        this.getSelectOptionForNested(val);
      });
    }
  }

  getFieldSchemaValueDetailsForSelectOption(fieldSchemaValueId: any, obj: any) {
    if (fieldSchemaValueId) {
      this._countryService
        .getFieldSchemaValueDetailsForSelectOption(
          fieldSchemaValueId,
          this.skipHeader
        )
        .subscribe((res) => {
          obj.value = res.description;
        });
    }
  }

  ngAfterContentInit() {
    this.ref.detectChanges();
  }

  ngOnDestroy() {}
}
